// ComprehensiveInHomeCareSection.js
import React from 'react';
import { ArrowRight } from 'lucide-react';
import comprehensiveInHomeCareImage from '../assets/comprehensive-in-home-care-image.jpg';

const ComprehensiveInHomeCareSection = () => {
  const services = [
    'Safe transfers between bed, wheelchair, or toilet',
    'Emotional companionship and encouragement throughout the day',
    'Light housekeeping and home organisation for safety and accessibility',
    'Medication reminders and coordination with healthcare professionals',
    'Nutritious meal preparation and feeding assistance',
    'Sensitive and discreet bowel and bladder care',
    'Personal hygiene support, including bathing, dressing, and grooming',
    'Range-of-motion exercises and mobility assistance'
  ];

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* Left Image */}
          <div>
            <img
              src={comprehensiveInHomeCareImage}
              alt="Carer assisting man with cane outdoors"
              className="w-full h-[420px] lg:h-[560px] rounded-2xl object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              In-Home Care
            </p>
            <h3 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Comprehensive In-Home Care for Lasting Comfort
            </h3>

            <div className="space-y-4 text-bnBody text-base leading-relaxed mb-8">
              <p>
                Living with a spinal cord injury can reshape every aspect of daily life, from mobility to emotional wellbeing. At B & N Enterprise, our specialised spinal cord injury care is designed to provide consistent, compassionate support that helps the people we care for live confidently and comfortably at home.
              </p>

              <p>
                Our skilled carers are trained to assist individuals with varying degrees of mobility, offering both practical and emotional support to enhance their overall wellbeing. Depending on your loved one's unique needs, our in-home care may include:
              </p>
            </div>

            <ul className="space-y-4">
              {services.map((service, index) => (
                <li key={index} className="flex items-start gap-4">
                  <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-full border border-bnAccent text-bnAccent">
                    <ArrowRight size={16} />
                  </span>
                  <span className="text-bnBody text-base leading-relaxed">{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComprehensiveInHomeCareSection;
